import { useQuery } from '@tanstack/react-query';
import { getToken } from '../internal/tokenCallback';
import { meAdmin } from '../queries/admin.queries';

export const useAdminMe = () => {
    return useQuery({
        queryKey: ['admin-me'],
        queryFn: async () => {
            const token = await getToken();
            if (token === '') {
                return null;
            }
            try {
                const response = await meAdmin();
                return response.user;
            } catch (e) {
                return null;
            }
        },
    });
};
